import { render, staticRenderFns } from "./WorkingHoursForm.vue?vue&type=template&id=0af60bfd&"
import script from "./WorkingHoursForm.vue?vue&type=script&lang=js&"
export * from "./WorkingHoursForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports